// @ts-strict-ignore
import { FreeCodeBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { FreeCodeBlock } from './FreeCodeBlock';

export const FreeCodeBlockMapping: BlockMapping<FreeCodeBlockData> = {
  invariant: [
    {
      prop: 'code',
      msg: 'Code required',
    },
  ],
  width: 'INSET',
  Component: FreeCodeBlock,
  AmpComponent: null,
};
